import React, { useEffect, useState } from "react";
import {
  getAllMatchesOddsSoccerAPI,
  getAllMatchesOddsTennisAPI,
} from "../service/soccer&tennis";
import { getAllMatchesOddsCricketAPI } from "../service/cricket";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

export default function Sports() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedGame, setSelectedGame] = React.useState(null);

  const cricketData = useSelector((state) =>
    state?.gameData?.cricketGames.map((item) => {
      return {
        ...item,
        sport: "cricket",
      };
    })
  );
  const tennisData = useSelector((state) =>
    state?.gameData?.tennisGames?.map((item) => {
      return {
        ...item,
        sport: "tennis",
      };
    })
  );
  const soccerData = useSelector((state) =>
    state?.gameData?.soccerGames?.map((item) => {
      return {
        ...item,
        sport: "soccer",
      };
    })
  );
  const [gameData, setGameData] = useState({
    cricket: [],
    tennis: [],
    soccer: [],
  });

  const getSoccerMatches = async () => {
    const { response, code } = await getAllMatchesOddsSoccerAPI();
    if (code == 200) {
      setGameData({
        ...gameData,
        soccer: response,
      });
      dispatch({
        type: "gameData/setSoccerGames",
        payload: response,
      });
    }
  };
  const getTennisMatches = async () => {
    const { response, code } = await getAllMatchesOddsTennisAPI();
    if (code == 200) {
      setGameData({
        ...gameData,
        tennis: response,
      });
      dispatch({
        type: "gameData/setTennisGames",
        payload: response,
      });
    }
  };
  const getCricketMatches = async () => {
    const { response, code } = await getAllMatchesOddsCricketAPI();
    if (code == 200) {
      setGameData({
        ...gameData,
        cricket: response,
      });
      dispatch({
        type: "gameData/setCricketGames",
        payload: response,
      });
    }
  };
  useEffect(() => {
    let interval;
    if (selectedGame == "cricket") {
      getCricketMatches();
      interval = setInterval(() => {
        getCricketMatches();
      }, 5000);
    } else if (selectedGame == "soccer") {
      getSoccerMatches();
      interval = setInterval(() => {
        getSoccerMatches();
      }, 5000);
    } else if (selectedGame == "tennis") {
      getTennisMatches();
      interval = setInterval(() => {
        getTennisMatches();
      }, 5000);
    } else {
      getSoccerMatches();
      getCricketMatches();
      getTennisMatches();
      interval = setInterval(() => {
        getSoccerMatches();
        getCricketMatches();
        getTennisMatches();
      }, 5000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [selectedGame]);
  return (
    <app-sports _nghost-ng-c3399274199="" className="ng-star-inserted">
      <div _ngcontent-ng-c3399274199="" className="row all-sports">
        <h3
          _ngcontent-ng-c3399274199=""
          className="quickHeader quicklink"
          style={{ display: "block" }}
        >
          Quick Links
        </h3>
        <ul
          _ngcontent-ng-c3399274199=""
          id="quickBoard"
          className="quick_link"
          style={{ display: "flex" }}
        >
          <li _ngcontent-ng-c3399274199="">
            <a _ngcontent-ng-c3399274199="" routerlink="/inplay" href="/inplay">
              <svg
                _ngcontent-ng-c3399274199=""
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                version="1.1"
                viewBox="0 0 129 129"
                enableBackground="new 0 0 129 129"
                width="512px"
                height="512px"
              >
                <g _ngcontent-ng-c3399274199="">
                  <g _ngcontent-ng-c3399274199="">
                    <g _ngcontent-ng-c3399274199="">
                      <path
                        _ngcontent-ng-c3399274199=""
                        d="m12.3,70.2c0,28.8 23.4,52.2 52.2,52.2s52.2-23.4 52.2-52.2c0-14.3-5.8-27.4-15.2-36.8l4.1-4.1 1.9,1.9c0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2c1.6-1.6 1.6-4.2 0-5.8l-9.5-9.5c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l1.9,1.9-4.5,4.5c-7.6-5.6-16.7-9.1-26.7-9.9v-3.5h9.1c2.3,0 4.1-1.8 4.1-4.1s-1.8-4.1-4.1-4.1h-27c-2.3,0-4.1,1.8-4.1,4.1s1.8,4.1 4.1,4.1h9.7v3.5c-27,2.1-48.2,24.6-48.2,52zm52.2-44c24.3-3.55271e-15 44.1,19.8 44.1,44.1 0,24.3-19.8,44.1-44.1,44.1-24.3,0-44.1-19.8-44.1-44.1 0-24.4 19.8-44.1 44.1-44.1z"
                        data-original="#000000"
                        data-old_color="#000000"
                        fill="currentColor"
                        className="active-path"
                      />
                      <path
                        _ngcontent-ng-c3399274199=""
                        d="m64.5,73.6h17.5c2.3,0 4.1-1.8 4.1-4.1 0-2.3-1.8-4.1-4.1-4.1h-13.4v-21.1c0-2.3-1.8-4.1-4.1-4.1-2.3,0-4.1,1.8-4.1,4.1v25.3c0,2.2 1.8,4 4.1,4z"
                        data-original="#000000"
                        data-old_color="#000000"
                        fill="currentColor"
                        className="active-path"
                      />
                    </g>
                  </g>
                </g>
              </svg>
              <span _ngcontent-ng-c3399274199="" className="bold">
                In-Play
              </span>
            </a>
          </li>
          <li _ngcontent-ng-c3399274199="" className="ng-star-inserted">
            <a
              _ngcontent-ng-c3399274199=""
              routerlink="/multimarket"
              href="/multimarket"
            >
              <svg
                _ngcontent-ng-c3399274199=""
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                version="1.1"
                id="Capa_1"
                x="0px"
                y="0px"
                width="512px"
                height="512px"
                viewBox="0 0 475.085 475.085"
                xmlSpace="preserve"
                style={{ enableBackground: "new 0 0 475.085 475.085" }}
              >
                <g _ngcontent-ng-c3399274199="">
                  <g _ngcontent-ng-c3399274199="">
                    <path
                      _ngcontent-ng-c3399274199=""
                      d="M379.577,247.395c-14.944-18.75-31.833-28.12-50.679-28.12V73.092c9.896,0,18.47-3.616,25.693-10.848   c7.238-7.233,10.858-15.802,10.858-25.697c0-9.9-3.62-18.464-10.858-25.697C347.368,3.617,338.795,0,328.898,0H146.179   c-9.9,0-18.464,3.617-25.697,10.85c-7.234,7.233-10.85,15.796-10.85,25.697c0,9.899,3.616,18.464,10.85,25.697   c7.233,7.232,15.8,10.848,25.697,10.848v146.179c-18.844,0-35.734,9.374-50.677,28.123c-14.941,18.75-22.414,39.824-22.414,63.242   c0,4.948,1.809,9.232,5.426,12.847c3.619,3.613,7.901,5.421,12.85,5.421h115.344l21.698,138.474   c0.95,5.141,3.996,7.707,9.135,7.707h0.291c2.274,0,4.235-0.808,5.851-2.423c1.615-1.619,2.614-3.572,2.994-5.855l14.558-137.902   h122.482c4.948,0,9.236-1.808,12.847-5.421c3.621-3.614,5.432-7.898,5.432-12.847C401.999,287.222,394.519,266.145,379.577,247.395   z M210.132,210.14c0,2.662-0.855,4.849-2.57,6.565c-1.713,1.714-3.903,2.57-6.567,2.57c-2.662,0-4.853-0.855-6.567-2.57   c-1.713-1.713-2.568-3.903-2.568-6.565V82.233c0-2.664,0.855-4.858,2.568-6.567c1.714-1.711,3.905-2.568,6.567-2.568   c2.664,0,4.854,0.854,6.567,2.568c1.714,1.712,2.57,3.903,2.57,6.567V210.14z"
                      data-original="#000000"
                      data-old_color="#000000"
                      fill="currentColor"
                      className="active-path"
                    />
                  </g>
                </g>
              </svg>
              <span _ngcontent-ng-c3399274199="" className="bold">
                Multi Markets
              </span>
            </a>
          </li>
          {/**/}
          {/**/}
          <li _ngcontent-ng-c3399274199="">
            <a
              onClick={() => {
                setSelectedGame("cricket");
              }}
              _ngcontent-ng-c3399274199=""
            >
              <svg
                _ngcontent-ng-c3399274199=""
                xmlns="http://www.w3.org/2000/svg"
                height="512px"
                viewBox="0 0 382.04857 382"
                width="512px"
              >
                <g _ngcontent-ng-c3399274199="">
                  <path
                    _ngcontent-ng-c3399274199=""
                    d="m321.050781 51.128906c-75.28125-69.972656-192.429687-67.832031-265.105469 4.839844-72.675781 72.675781-74.8125 189.824219-4.839843 265.105469zm-223.679687 207.621094-11.523438 11.527344c-2.734375 2.734375-7.167968 2.734375-9.902344 0-2.734374-2.734375-2.734374-7.167969 0-9.902344l11.527344-11.523438c2.734375-2.734374 7.167969-2.734374 9.898438 0 2.734375 2.734376 2.734375 7.164063 0 9.898438zm28.8125-28.8125-11.523438 11.523438c-2.734375 2.734374-7.164062 2.734374-9.898437 0-2.734375-2.734376-2.734375-7.167969 0-9.898438l11.523437-11.527344c2.734375-2.734375 7.167969-2.734375 9.902344 0 2.730469 2.734375 2.730469 7.167969 0 9.902344zm28.8125-28.8125-11.523438 11.527344c-2.734375 2.734375-7.167968 2.734375-9.902344 0-2.730468-2.734375-2.730468-7.167969 0-9.902344l11.527344-11.523438c2.734375-2.734374 7.164063-2.734374 9.898438 0 2.734375 2.734376 2.734375 7.164063 0 9.898438zm28.816406-28.8125-11.527344 11.523438c-2.730468 2.734374-7.164062 2.734374-9.898437 0-2.734375-2.734376-2.734375-7.167969 0-9.902344l11.527343-11.523438c2.734376-2.734375 7.164063-2.734375 9.898438 0s2.734375 7.164063 0 9.898438zm28.8125-28.816406-11.523438 11.527344c-2.734374 2.730468-7.167968 2.730468-9.902343 0-2.730469-2.734376-2.730469-7.167969 0-9.902344l11.527343-11.523438c2.734376-2.734375 7.167969-2.734375 9.898438 0 2.734375 2.734375 2.734375 7.164063 0 9.898438zm28.816406-28.8125-11.527344 11.527344c-2.734374 2.730468-7.164062 2.730468-9.898437 0-2.734375-2.734376-2.734375-7.167969 0-9.902344l11.523437-11.527344c2.734376-2.730469 7.167969-2.730469 9.902344 0 2.734375 2.734375 2.734375 7.167969 0 9.902344zm28.8125-28.8125-11.527344 11.523437c-2.734374 2.734375-7.164062 2.734375-9.898437 0-2.734375-2.730469-2.734375-7.164062 0-9.898437l11.523437-11.527344c2.734376-2.734375 7.167969-2.734375 9.898438 0 2.734375 2.734375 2.734375 7.167969 0 9.902344zm28.171875-38.070313c2.734375 2.730469 2.734375 7.164063 0 9.898438l-11.523437 11.523437c-2.734375 2.734375-7.167969 2.734375-9.902344 0-2.730469-2.734375-2.730469-7.164062 0-9.898437l11.527344-11.523438c2.734375-2.734375 7.164062-2.734375 9.898437 0zm-38.710937-5.765625 11.519531-11.523437c2.734375-2.734375 7.167969-2.734375 9.898437 0 2.734376 2.734375 2.734376 7.164062 0 9.898437l-11.523437 11.527344c-2.734375 2.734375-7.164063 2.734375-9.898437 0-2.734376-2.734375-2.734376-7.167969 0-9.902344zm-28.171875 28.175782 11.523437-11.527344c2.734375-2.734375 7.164063-2.734375 9.898438 0s2.734375 7.167968 0 9.902344l-11.523438 11.523437c-2.734375 2.734375-7.167968 2.734375-9.902344 0-2.730468-2.734375-2.730468-7.167969 0-9.898437zm-28.816407 28.8125 11.527344-11.527344c2.734375-2.734375 7.164063-2.734375 9.898438 0s2.734375 7.167968 0 9.902344l-11.527344 11.523437c-2.730469 2.734375-7.164062 2.734375-9.898438 0-2.734374-2.734375-2.734374-7.167969 0-9.902344zm-28.8125 28.8125 11.523438-11.527344c2.734375-2.730469 7.167969-2.730469 9.898438 0 2.734374 2.734375 2.734374 7.167968 0 9.902344l-11.523438 11.523437c-2.734375 2.734375-7.164062 2.734375-9.898438 0-2.734374-2.730469-2.734374-7.164063 0-9.898437zm-28.816406 28.816406 11.527344-11.53125c2.734375-2.730469 7.167969-2.730469 9.902344 0 2.734375 2.734375 2.734375 7.167968 0 9.902344l-11.527344 11.527343c-2.734375 2.734375-7.167969 2.734375-9.902344 0s-2.734375-7.164062 0-9.898437zm-28.8125 28.808594 11.523438-11.523438c2.734375-2.734375 7.167968-2.734375 9.902344 0 2.734374 2.730469 2.734374 7.164062 0 9.898438l-11.527344 11.523437c-2.734375 2.734375-7.164063 2.734375-9.898438 0-2.734375-2.730469-2.734375-7.164063 0-9.898437zm-28.8125 28.8125 11.523438-11.523438c2.734375-2.734375 7.167968-2.734375 9.902344 0 2.734374 2.734375 2.734374 7.167969 0 9.902344l-11.527344 11.523437c-2.730469 2.734375-7.164063 2.734375-9.898438 0s-2.734375-7.164062 0-9.898437zm-28.8125 28.8125 11.523438-11.523438c2.734375-2.734375 7.167968-2.734375 9.898437 0 2.734375 2.734375 2.734375 7.164062 0 9.898438l-11.523437 11.527343c-2.734375 2.734375-7.167969 2.734375-9.902344 0-2.730469-2.734375-2.730469-7.167969 0-9.898437zm-23.222656 40.125c-2.832031 0-5.386719-1.707032-6.46875-4.320313-1.085938-2.617187-.484375-5.628906 1.515625-7.628906l11.527344-11.527344c2.734375-2.734375 7.164062-2.734375 9.898437 0s2.734375 7.167969 0 9.902344l-11.527344 11.523437c-1.308593 1.3125-3.089843 2.050782-4.945312 2.050782zm12.335938 5.335937 11.523437-11.523437c2.734375-2.734376 7.167969-2.734376 9.902344 0 2.734375 2.730468 2.734375 7.164062 0 9.898437l-11.527344 11.527344c-2.730469 2.734375-7.164063 2.734375-9.898437 0-2.734376-2.730469-2.734376-7.164063 0-9.898438zm0 0"
                    data-original="#000000"
                    data-old_color="#000000"
                    fill="currentColor"
                    className="active-path"
                  />
                  <path
                    _ngcontent-ng-c3399274199=""
                    d="m61.003906 330.972656c75.277344 69.96875 192.425782 67.824219 265.09375-4.851562 72.679688-72.667969 74.820313-189.820313 4.851563-265.097656zm223.679688-207.621094 11.523437-11.527343c2.734375-2.730469 7.167969-2.730469 9.902344 0 2.730469 2.734375 2.730469 7.167969 0 9.902343l-11.527344 11.523438c-2.734375 2.734375-7.167969 2.734375-9.902343 0-2.734376-2.734375-2.734376-7.164062 0-9.898438zm-28.816406 28.8125 11.527343-11.523437c2.730469-2.734375 7.164063-2.734375 9.898438 0 2.734375 2.730469 2.734375 7.164063 0 9.898437l-11.523438 11.523438c-2.734375 2.734375-7.167969 2.734375-9.902343 0-2.734376-2.730469-2.734376-7.164062 0-9.898438zm-28.8125 28.8125 11.527343-11.527343c2.734375-2.730469 7.164063-2.730469 9.898438 0 2.734375 2.734375 2.734375 7.167969 0 9.902343l-11.523438 11.523438c-2.734375 2.734375-7.167969 2.734375-9.898437 0-2.734375-2.734375-2.734375-7.164062 0-9.898438zm-28.8125 28.8125 11.523437-11.523437c2.734375-2.734375 7.167969-2.734375 9.902344 0s2.734375 7.164063 0 9.898437l-11.527344 11.527344c-2.734375 2.734375-7.167969 2.734375-9.898437 0-2.734376-2.734375-2.734376-7.167968 0-9.898437zm-28.816407 28.816407 11.527344-11.527344c2.734375-2.730469 7.164063-2.730469 9.898437 0 2.734376 2.734375 2.734376 7.167969 0 9.902344l-11.523437 11.523437c-2.734375 2.734375-7.167969 2.734375-9.902344 0s-2.734375-7.164062 0-9.898437zm-28.8125 28.8125 11.527344-11.523438c2.730469-2.734375 7.164063-2.734375 9.898437 0 2.734376 2.730469 2.734376 7.164063 0 9.898438l-11.527343 11.527343c-2.734375 2.734376-7.164063 2.734376-9.898438 0-2.734375-2.734374-2.734375-7.167968 0-9.902343zm-28.808593 28.8125 11.523437-11.523438c2.734375-2.734375 7.164063-2.734375 9.898437 0 2.734376 2.734375 2.734376 7.164063 0 9.898438l-11.523437 11.527343c-2.734375 2.730469-7.164063 2.730469-9.898437 0-2.734376-2.734374-2.734376-7.167968 0-9.902343zm-23.222657 40.121093c-2.832031 0-5.386719-1.707031-6.46875-4.320312-1.082031-2.617188-.484375-5.628906 1.515625-7.628906l11.527344-11.527344c2.734375-2.734375 7.164062-2.734375 9.898438 0 2.734374 2.734375 2.734374 7.167969 0 9.902344l-11.527344 11.527344c-1.3125 1.3125-3.089844 2.046874-4.945313 2.046874zm33.761719 3.710938-11.523438 11.527344c-2.734374 2.734375-7.167968 2.734375-9.902343 0s-2.734375-7.164063 0-9.898438l11.527343-11.527344c2.730469-2.734374 7.164063-2.734374 9.898438 0 2.734375 2.734376 2.734375 7.167969 0 9.902344zm28.171875-28.171875-11.523437 11.523437c-2.734376 2.734376-7.167969 2.734376-9.902344 0-2.730469-2.734374-2.730469-7.164062 0-9.898437l11.527344-11.527344c2.734374-2.730469 7.164062-2.730469 9.898437 0 2.734375 2.734375 2.734375 7.167969 0 9.902344zm28.8125-28.8125-11.527344 11.527344c-2.734375 2.734375-7.167969 2.734375-9.898437 0-2.734375-2.734375-2.734375-7.167969 0-9.902344l11.523437-11.523437c2.734375-2.734376 7.167969-2.734376 9.902344 0 2.734375 2.734374 2.734375 7.167968 0 9.902343zm28.8125-28.8125-11.523437 11.527344c-2.734376 2.734375-7.167969 2.734375-9.902344 0s-2.734375-7.167969 0-9.902344l11.527344-11.523437c2.730468-2.734376 7.164062-2.734376 9.898437 0 2.734375 2.734374 2.734375 7.164062 0 9.898437zm28.816406-28.816406-11.53125 11.53125c-2.734375 2.730469-7.164062 2.730469-9.898437 0-2.734375-2.734375-2.734375-7.167969 0-9.902344l11.527344-11.527344c2.734374-2.734375 7.167968-2.734375 9.898437 0 2.734375 2.734375 2.734375 7.167969 0 9.898438zm28.8125-28.8125-11.527343 11.527343c-2.730469 2.734376-7.164063 2.734376-9.898438 0-2.734375-2.734374-2.734375-7.167968 0-9.902343l11.527344-11.523438c2.734375-2.734375 7.164062-2.734375 9.898437 0s2.734375 7.164063 0 9.898438zm28.8125-28.8125-11.527343 11.527343c-2.734376 2.734376-7.164063 2.734376-9.898438 0-2.734375-2.734374-2.734375-7.167968 0-9.902343l11.523438-11.523438c2.734374-2.734375 7.167968-2.734375 9.902343 0s2.734375 7.164063 0 9.898438zm28.8125-28.8125-11.523437 11.523437c-2.734375 2.734375-7.167969 2.734375-9.902344 0-2.734375-2.730468-2.734375-7.164062 0-9.898437l11.527344-11.527344c2.734375-2.730469 7.164062-2.730469 9.898437 0 2.734375 2.734375 2.734375 7.167969 0 9.902344zm28.171875-38.070313c2.734375 2.730469 2.734375 7.164063 0 9.898438l-11.523437 11.523437c-2.734375 2.734375-7.167969 2.734375-9.898438 0-2.734375-2.730469-2.734375-7.164062 0-9.898437l11.523438-11.523438c2.734375-2.734375 7.167969-2.734375 9.898437 0zm-17.285156-7.390625-11.527344 11.527344c-2.734375 2.734375-7.164062 2.734375-9.898437 0s-2.734375-7.167969 0-9.902344l11.523437-11.523437c2.734375-2.734375 7.167969-2.734375 9.902344 0 2.730469 2.734375 2.730469 7.164062 0 9.898437zm0 0"
                    data-original="#000000"
                    data-old_color="#000000"
                    fill="currentColor"
                    className="active-path"
                  />
                </g>
              </svg>
              <span _ngcontent-ng-c3399274199="" className="bold">
                Cricket
              </span>
            </a>
          </li>
          <li _ngcontent-ng-c3399274199="">
            <a
              onClick={() => {
                setSelectedGame("soccer");
              }}
              _ngcontent-ng-c3399274199=""
            >
              <svg
                _ngcontent-ng-c3399274199=""
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                version="1.1"
                id="Capa_1"
                x="0px"
                y="0px"
                width="512px"
                height="512px"
                viewBox="0 0 72.371 72.372"
                xmlSpace="preserve"
                style={{ enableBackground: "new 0 0 72.371 72.372" }}
              >
                <g _ngcontent-ng-c3399274199="">
                  <g _ngcontent-ng-c3399274199="">
                    <path
                      _ngcontent-ng-c3399274199=""
                      d="M22.57,2.648c-4.489,1.82-8.517,4.496-11.971,7.949C7.144,14.051,4.471,18.08,2.65,22.568C0.892,26.904,0,31.486,0,36.186   c0,4.699,0.892,9.281,2.65,13.615c1.821,4.489,4.495,8.518,7.949,11.971c3.454,3.455,7.481,6.129,11.971,7.949   c4.336,1.76,8.917,2.649,13.617,2.649c4.7,0,9.28-0.892,13.616-2.649c4.488-1.82,8.518-4.494,11.971-7.949   c3.455-3.453,6.129-7.48,7.949-11.971c1.758-4.334,2.648-8.916,2.648-13.615c0-4.7-0.891-9.282-2.648-13.618   c-1.82-4.488-4.496-8.518-7.949-11.971s-7.479-6.129-11.971-7.949C45.467,0.891,40.887,0,36.187,0   C31.487,0,26.906,0.891,22.57,2.648z M9.044,51.419c-1.743-1.094-3.349-2.354-4.771-3.838c-2.172-6.112-2.54-12.729-1.101-19.01   c0.677-1.335,1.447-2.617,2.318-3.845c0.269-0.379,0.518-0.774,0.806-1.142l8.166,4.832c0,0.064,0,0.134,0,0.205   c-0.021,4.392,0.425,8.752,1.313,13.049c0.003,0.02,0.006,0.031,0.01,0.049l-6.333,9.93C9.314,51.579,9.177,51.503,9.044,51.419z    M33.324,68.206c1.409,0.719,2.858,1.326,4.347,1.82c-6.325,0.275-12.713-1.207-18.36-4.447L33,68.018   C33.105,68.085,33.212,68.149,33.324,68.206z M33.274,65.735L17.12,62.856c-1.89-2.295-3.59-4.723-5.051-7.318   c-0.372-0.66-0.787-1.301-1.102-1.99l6.327-9.92c0.14,0.035,0.296,0.072,0.473,0.119c3.958,1.059,7.986,1.812,12.042,2.402   c0.237,0.033,0.435,0.062,0.604,0.08l7.584,13.113c-1.316,1.85-2.647,3.69-4.007,5.51C33.764,65.155,33.524,65.446,33.274,65.735z    M60.15,60.149c-1.286,1.287-2.651,2.447-4.08,3.481c-0.237-1.894-0.646-3.75-1.223-5.563l8.092-15.096   c2.229-1.015,4.379-2.166,6.375-3.593c0.261-0.185,0.478-0.392,0.646-0.618C69.374,46.561,66.104,54.196,60.15,60.149z    M59.791,40.571c0.301,0.574,0.598,1.154,0.896,1.742l-7.816,14.58c-0.045,0.01-0.088,0.02-0.133,0.026   c-4.225,0.789-8.484,1.209-12.779,1.229l-7.8-13.487c1.214-2.254,2.417-4.517,3.61-6.781c0.81-1.536,1.606-3.082,2.401-4.627   l16.143-1.658C56.29,34.495,58.163,37.457,59.791,40.571z M56.516,23.277c-0.766,2.023-1.586,4.025-2.401,6.031l-15.726,1.615   c-0.188-0.248-0.383-0.492-0.588-0.725c-1.857-2.103-3.726-4.193-5.592-6.289c0.017-0.021,0.034-0.037,0.051-0.056   c-0.753-0.752-1.508-1.504-2.261-2.258l4.378-13.181c0.302-0.08,0.606-0.147,0.913-0.18c2.38-0.242,4.763-0.516,7.149-0.654   c1.461-0.082,2.93-0.129,4.416-0.024l10.832,12.209C57.314,20.943,56.95,22.124,56.516,23.277z M60.15,12.221   c2.988,2.99,5.302,6.402,6.938,10.047c-2.024-1.393-4.188-2.539-6.463-3.473c-0.354-0.146-0.717-0.275-1.086-0.402L48.877,6.376   c0.074-0.519,0.113-1.039,0.129-1.563C53.062,6.464,56.864,8.936,60.15,12.221z M25.334,4.182c0.042,0.031,0.062,0.057,0.086,0.064   c2.437,0.842,4.654,2.082,6.744,3.553l-4.09,12.317c-0.021,0.006-0.041,0.012-0.061,0.021c-0.837,0.346-1.69,0.656-2.514,1.031   c-3.395,1.543-6.705,3.252-9.823,5.301l-8.071-4.775c0.012-0.252,0.055-0.508,0.141-0.736c0.542-1.444,1.075-2.896,1.688-4.311   c0.472-1.09,1.01-2.143,1.597-3.172c0.384-0.424,0.782-0.844,1.192-1.254c3.833-3.832,8.363-6.553,13.186-8.162   C25.384,4.098,25.358,4.139,25.334,4.182z"
                      data-original="#000000"
                      data-old_color="#000000"
                      fill="currentColor"
                      className="active-path"
                    />
                  </g>
                </g>
              </svg>
              <span _ngcontent-ng-c3399274199="" className="bold">
                Soccer
              </span>
            </a>
          </li>
          <li _ngcontent-ng-c3399274199="" style={{ borderRight: "none" }}>
            <a
              onClick={() => {
                setSelectedGame("tennis");
              }}
              _ngcontent-ng-c3399274199=""
            >
              <svg
                _ngcontent-ng-c3399274199=""
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                version="1.1"
                id="Capa_1"
                x="0px"
                y="0px"
                viewBox="0 0 40.933 40.933"
                xmlSpace="preserve"
                width="512px"
                height="512px"
                style={{ enableBackground: "new 0 0 40.933 40.933" }}
              >
                <g _ngcontent-ng-c3399274199="">
                  <g _ngcontent-ng-c3399274199="">
                    <g _ngcontent-ng-c3399274199="">
                      <g _ngcontent-ng-c3399274199="">
                        <path
                          _ngcontent-ng-c3399274199=""
                          d="M18.546,0.079C13.967,0.506,9.497,2.477,5.984,5.988c-3.513,3.51-5.482,7.98-5.908,12.565     c5.028,0.583,10.374,3.153,14.763,7.542c4.391,4.39,6.964,9.74,7.542,14.764c4.592-0.426,9.051-2.396,12.567-5.905     c3.512-3.509,5.479-7.981,5.903-12.565c-5.016-0.582-10.371-3.152-14.76-7.542C21.705,10.458,19.132,5.107,18.546,0.079z"
                          data-original="#010002"
                          data-old_color="#010002"
                          fill="currentColor"
                          className="active-path"
                        />
                        <path
                          _ngcontent-ng-c3399274199=""
                          d="M40.933,19.85c-0.149-5.035-2.141-10.023-5.979-13.866C31.114,2.141,26.12,0.156,21.085,0     c0.566,4.397,2.901,9.122,6.815,13.037C31.814,16.952,36.533,19.283,40.933,19.85z"
                          data-original="#010002"
                          data-old_color="#010002"
                          fill="currentColor"
                          className="active-path"
                        />
                        <path
                          _ngcontent-ng-c3399274199=""
                          d="M0.001,21.09c0.148,5.033,2.141,10.022,5.983,13.863c3.839,3.839,8.827,5.834,13.861,5.98     c-0.566-4.391-2.898-9.113-6.814-13.028C9.119,23.992,4.395,21.66,0.001,21.09z"
                          data-original="#010002"
                          data-old_color="#010002"
                          fill="currentColor"
                          className="active-path"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
              <span _ngcontent-ng-c3399274199="" className="bold">
                Tennis
              </span>
            </a>
          </li>
        </ul>
        <h3
          _ngcontent-ng-c3399274199=""
          className="quickHeader"
          style={{ display: "block", cursor: "pointer" }}
        >
          <span _ngcontent-ng-c3399274199="" className="bold">
            <a _ngcontent-ng-c3399274199="">All Sports</a>
          </span>
        </h3>
      </div>
      <div _ngcontent-ng-c3399274199="">
        <div _ngcontent-ng-c3399274199="" className="sidebar">
          <nav
            _ngcontent-ng-c3399274199=""
            className="sidebar-nav ps ps--active-y"
          >
            <ul _ngcontent-ng-c3399274199="" className="account-nav">
              {/**/}
              {selectedGame == null ? (
                <div
                  _ngcontent-ng-c3399274199=""
                  className="sideW ng-star-inserted"
                >
                  <li
                    _ngcontent-ng-c3399274199=""
                    className="nav-item nav-dropdown ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c3399274199=""
                      onClick={() => {
                        setSelectedGame("cricket");
                      }}
                      className="nav-link nav-dropdown-toggle ng-star-inserted"
                    >
                      {" "}
                      Cricket{" "}
                    </a>
                    {/**/}
                    {/**/}
                    {/**/}
                  </li>
                  <li
                    _ngcontent-ng-c3399274199=""
                    className="nav-item nav-dropdown ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c3399274199=""
                      onClick={() => {
                        setSelectedGame("tennis");
                      }}
                      className="nav-link nav-dropdown-toggle ng-star-inserted"
                    >
                      {" "}
                      Tennis{" "}
                    </a>
                    {/**/}
                    {/**/}
                    {/**/}
                  </li>
                  <li
                    _ngcontent-ng-c3399274199=""
                    className="nav-item nav-dropdown ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c3399274199=""
                      href="javascript:;"
                      className="nav-link nav-dropdown-toggle ng-star-inserted"
                    >
                      {" "}
                      Casino{" "}
                    </a>
                    {/**/}
                    {/**/}
                    {/**/}
                  </li>
                  <li
                    _ngcontent-ng-c3399274199=""
                    className="nav-item nav-dropdown ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c3399274199=""
                      onClick={() => {
                        setSelectedGame("soccer");
                      }}
                      className="nav-link nav-dropdown-toggle ng-star-inserted"
                    >
                      {" "}
                      Soccer{" "}
                    </a>
                    {/**/}
                    {/**/}
                    {/**/}
                  </li>
                  <li
                    _ngcontent-ng-c3399274199=""
                    className="nav-item nav-dropdown ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c3399274199=""
                      href="javascript:;"
                      className="nav-link nav-dropdown-toggle ng-star-inserted"
                    >
                      {" "}
                      Horse Racing{" "}
                    </a>
                    {/**/}
                    {/**/}
                    {/**/}
                  </li>
                  <li
                    _ngcontent-ng-c3399274199=""
                    className="nav-item nav-dropdown ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c3399274199=""
                      href="javascript:;"
                      className="nav-link nav-dropdown-toggle ng-star-inserted"
                    >
                      {" "}
                      Greyhound Racing{" "}
                    </a>
                    {/**/}
                    {/**/}
                    {/**/}
                  </li>
                  <li
                    _ngcontent-ng-c3399274199=""
                    className="nav-item nav-dropdown ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c3399274199=""
                      href="javascript:;"
                      className="nav-link nav-dropdown-toggle ng-star-inserted"
                    >
                      {" "}
                      Kabaddi{" "}
                    </a>
                    {/**/}
                    {/**/}
                    {/**/}
                  </li>
                  <li
                    _ngcontent-ng-c3399274199=""
                    className="nav-item nav-dropdown ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c3399274199=""
                      href="javascript:;"
                      className="nav-link nav-dropdown-toggle ng-star-inserted"
                    >
                      {" "}
                      Basketball{" "}
                    </a>
                    {/**/}
                    {/**/}
                    {/**/}
                  </li>
                  <li
                    _ngcontent-ng-c3399274199=""
                    className="nav-item nav-dropdown ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c3399274199=""
                      href="javascript:;"
                      className="nav-link nav-dropdown-toggle ng-star-inserted"
                    >
                      {" "}
                      Politics{" "}
                    </a>
                    {/**/}
                    {/**/}
                    {/**/}
                  </li>
                  <li
                    _ngcontent-ng-c3399274199=""
                    className="nav-item nav-dropdown ng-star-inserted"
                  >
                    {/**/}
                    {/**/}
                    <a
                      _ngcontent-ng-c3399274199=""
                      href="javascript:;"
                      className="nav-link nav-dropdown-toggle ng-star-inserted"
                    >
                      {" "}
                      Virtual Sports{" "}
                    </a>
                    {/**/}
                  </li>
                  <li
                    _ngcontent-ng-c3399274199=""
                    className="nav-item nav-dropdown ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c3399274199=""
                      href="javascript:;"
                      className="nav-link nav-dropdown-toggle ng-star-inserted"
                    >
                      {" "}
                      Binary{" "}
                    </a>
                    {/**/}
                    {/**/}
                    {/**/}
                  </li>
                  <li
                    _ngcontent-ng-c3399274199=""
                    className="nav-item nav-dropdown ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c3399274199=""
                      href="javascript:;"
                      className="nav-link nav-dropdown-toggle ng-star-inserted"
                    >
                      {" "}
                      Lottery{" "}
                    </a>
                    {/**/}
                    {/**/}
                    {/**/}
                  </li>
                  {/**/}
                </div>
              ) : (
                <div
                  _ngcontent-ng-c3399274199=""
                  className="sideW ng-star-inserted"
                >
                  {gameData[selectedGame]?.map((item) => (
                    <li
                      _ngcontent-ng-c3399274199=""
                      className="nav-item nav-dropdown ng-star-inserted"
                    >
                      <a
                        _ngcontent-ng-c3399274199=""
                        onClick={() => {
                         navigate(`/game/${selectedGame}/${item[selectedGame+"Id"]}`)
                        }}
                        className="nav-link nav-dropdown-toggle ng-star-inserted"
                      >
                        {" "}
                        {item?.eventName}{" "}
                      </a>
                    </li>
                  ))}
                </div>
              )}
            </ul>
          </nav>
        </div>
      </div>
      <div
        _ngcontent-ng-c3399274199=""
        id="ageconfirmationModal"
        tabIndex={-1}
        aria-labelledby="ageconfirmationModal"
        aria-hidden="true"
        className="modal fade"
      >
        <div
          _ngcontent-ng-c3399274199=""
          className="modal-dialog modal-dialog-centered"
        >
          <div _ngcontent-ng-c3399274199="" className="modal-content">
            <div _ngcontent-ng-c3399274199="" className="login-popup-content">
              <div _ngcontent-ng-c3399274199="" className="modal-body">
                <div _ngcontent-ng-c3399274199="" className="header-popup">
                  <a
                    _ngcontent-ng-c3399274199=""
                    data-bs-dismiss="modal"
                    className="ui-link"
                  />
                </div>
                <div
                  _ngcontent-ng-c3399274199=""
                  className="login-panel-container confirm-container"
                >
                  <div _ngcontent-ng-c3399274199="" className="confirm-text">
                    <div
                      _ngcontent-ng-c3399274199=""
                      className="text1 text-confirm-bold"
                    >
                      Non-Gambling Territories.
                    </div>
                    <hr _ngcontent-ng-c3399274199="" className="confirm-line" />
                    <div _ngcontent-ng-c3399274199="" className="text2">
                      Connecting to our site from non gambling countries, it
                      will be User's responsibility to ensure that their use of
                      the service is lawful.
                    </div>
                  </div>
                  <div _ngcontent-ng-c3399274199="" className="confirm-text">
                    <div
                      _ngcontent-ng-c3399274199=""
                      className="text1 text-confirm-bold"
                    >
                      Underage gambling is prohibited.
                    </div>
                    <hr _ngcontent-ng-c3399274199="" className="confirm-line" />
                    <div _ngcontent-ng-c3399274199="" className="text2">
                      Please confirm if you are{" "}
                      <span _ngcontent-ng-c3399274199="">
                        18 years old and above
                      </span>{" "}
                      as of today.{" "}
                    </div>
                  </div>
                  <div _ngcontent-ng-c3399274199="" className="confirm-button">
                    {/**/}
                    <button
                      _ngcontent-ng-c3399274199=""
                      routerlink="/login"
                      data-bs-dismiss="modal"
                      className="btn-verification btn-confirm ng-star-inserted"
                      tabIndex={0}
                    >
                      <span _ngcontent-ng-c3399274199="">Confirm</span>
                    </button>
                    {/**/}
                    <button
                      _ngcontent-ng-c3399274199=""
                      data-bs-dismiss="modal"
                      className="btn-verification"
                    >
                      <a
                        _ngcontent-ng-c3399274199=""
                        style={{ color: "#ffffff", textDecoration: "none" }}
                      >
                        <span _ngcontent-ng-c3399274199="">Exit</span>
                      </a>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-sports>
  );
}
